var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPyramid1 = function SvgIconPyramid1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.075 5 8.456 2.259a.531.531 0 0 0-.912 0L5.925 5h4.15Z",
    fill: "#2CCCD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.153 8 1.181-2h5.332l1.18 2H4.154ZM2.381 11l1.182-2h8.874l1.182 2H2.38ZM1.79 12l-.717 1.216a.521.521 0 0 0 .456.784H14.47a.521.521 0 0 0 .456-.784L14.21 12H1.791Z",
    fill: "#DDDEE1"
  })));
};
export default SvgIconPyramid1;